import { Component, Input, OnInit, Output ,EventEmitter} from '@angular/core';
import { FormBuilder, FormGroup,Validators } from '@angular/forms';
import { budgetBO } from '../budgetimport.model';

@Component({
  selector: 'app-budgetimport-form',
  templateUrl: './budgetimport-form.component.html',
  styleUrls: ['./budgetimport-form.component.scss']
})

export class BudgetimportFormComponent implements OnInit {
  CaseForm: FormGroup;

  @Input() budgetImportData:budgetBO= new budgetBO();
  @Output() dataEmitFromBudget= new EventEmitter<budgetBO>();
  
  constructor(private formBuilder: FormBuilder) { 
    this.CaseForm = this.formBuilder.group({
      caseManagerName: [' ', Validators.required],
      Telephone: ['', [Validators.minLength(14), Validators.maxLength(14)]],
      Email: ['', [Validators.email]],
      Fax: ['', [Validators.minLength(14), Validators.maxLength(14)]],
      Alternate_Fax: ['', [Validators.minLength(14), Validators.maxLength(14)]],
      County: ['']
    });
  }

  ngOnInit(): void {   
    document.getElementById("openModal").click();
  }

  closeFun()
  {
    this.budgetImportData.edit= false;
    this.dataEmitFromBudget.emit(this.budgetImportData);
  }

}
